<template>
  <el-drawer
    :visible.sync="drawerVisible"
    :append-to-body="true"
    size="74%"
    custom-class="crm-customer-drawer"
    title="客户详情页"
  >
    <div v-if="customer" class="crm-detail">
      <div class="crm-detail-main">
        <div class="crm-hero">
          <div>
            <div class="crm-hero-name">{{ customer.name }}</div>
            <div class="crm-hero-meta">
              <crm-phone-field
                :phone="customer.phone"
                prefix="主号码"
                status="pending"
              />
              <span>· {{ customer.companyName || "未填写公司名称" }}</span>
              <span>· {{ customer.ownerName || "公海池" }}</span>
            </div>
            <div class="crm-tags">
              <el-tag size="mini" :type="mainStatusType">{{
                customer.mainStatus
              }}</el-tag>
              <el-tag size="mini" :type="intentionType">{{
                customer.intentionLevel
              }}</el-tag>
              <el-tag size="mini" effect="plain">{{
                customer.poolType
              }}</el-tag>
              <el-tag size="mini" :type="countdownType">{{
                countdownLabel
              }}</el-tag>
            </div>
          </div>
          <div class="crm-score">
            <span>系统评分</span>
            <strong>{{ customer.score || 0 }}</strong>
          </div>
        </div>

        <el-row :gutter="16">
          <el-col :span="12">
            <el-card shadow="never">
              <div slot="header">基本信息</div>
              <div class="crm-kv">
                <span>姓名</span><b>{{ customer.name }}</b>
              </div>
              <div class="crm-kv">
                <span>主手机号</span>
                <b
                  ><crm-phone-field
                    :phone="customer.phone"
                    prefix="主号"
                    status="pending"
                /></b>
              </div>
              <div class="crm-kv" v-if="customer.backupPhone">
                <span>备用电话</span>
                <b
                  ><crm-phone-field
                    :phone="customer.backupPhone"
                    prefix="备用"
                    status="pending"
                /></b>
              </div>
              <div class="crm-kv">
                <span>微信号</span><b>{{ customer.wechat || "未填写" }}</b>
              </div>
              <div class="crm-kv">
                <span>公司名称</span
                ><b>{{ customer.companyName || "未填写" }}</b>
              </div>
              <div class="crm-kv">
                <span>地区</span><b>{{ customer.region || "未填写" }}</b>
              </div>
              <div class="crm-kv">
                <span>来源</span
                ><b
                  >{{ customer.source }} /
                  {{ customer.sourceDetail || "未填写" }}</b
                >
              </div>
              <div class="crm-kv">
                <span>录入时间</span><b>{{ customer.enteredAt || "暂无" }}</b>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card shadow="never">
              <div slot="header">状态信息</div>
              <div class="crm-kv">
                <span>主状态</span><b>{{ customer.mainStatus }}</b>
              </div>
              <div class="crm-kv">
                <span>子状态</span><b>{{ customer.subStatus }}</b>
              </div>
              <div class="crm-kv">
                <span>意向等级</span><b>{{ customer.intentionLevel }}</b>
              </div>
              <div class="crm-kv">
                <span>是否已加微信</span
                ><b>{{ customer.hasWeChat ? "是" : "否" }}</b>
              </div>
              <div class="crm-kv">
                <span>最近跟进时间</span
                ><b>{{ customer.lastFollowTime || "暂无" }}</b>
              </div>
              <div class="crm-kv">
                <span>下次跟进时间</span
                ><b>{{ customer.nextFollowTime || "未设置" }}</b>
              </div>
              <div class="crm-kv">
                <span>当前规则</span
                ><b>{{ customer.currentRule || "待配置" }}</b>
              </div>
              <div class="crm-call-note">
                当前仅为网页点击电话按钮的预留入口。后续将支持网页点击后，由已登录手机
                App 自动调起拨号。
              </div>
            </el-card>
          </el-col>
        </el-row>

        <el-card shadow="never" style="margin-top: 16px">
          <div slot="header">标签区</div>
          <div class="crm-label-group">
            <div class="crm-label-item">
              <span>业务标签</span>
              <div>
                <el-tag
                  v-for="tag in customer.businessTags || []"
                  :key="tag"
                  size="mini"
                  effect="plain"
                  >{{ tag }}</el-tag
                >
              </div>
            </div>
            <div class="crm-label-item">
              <span>风险标签</span>
              <div>
                <el-tag
                  v-for="tag in customer.riskTags || []"
                  :key="tag"
                  size="mini"
                  type="danger"
                  effect="plain"
                  >{{ tag }}</el-tag
                >
              </div>
            </div>
            <div class="crm-label-item">
              <span>管理标签</span>
              <div>
                <el-tag
                  v-for="tag in customer.manageTags || []"
                  :key="tag"
                  size="mini"
                  type="warning"
                  effect="plain"
                  >{{ tag }}</el-tag
                >
              </div>
            </div>
            <div class="crm-label-item">
              <span>自定义标签</span>
              <div>
                <el-tag
                  v-for="tag in customer.customTags || []"
                  :key="tag"
                  size="mini"
                  type="success"
                  effect="plain"
                  >{{ tag }}</el-tag
                >
              </div>
            </div>
          </div>
        </el-card>

        <el-row :gutter="16" style="margin-top: 16px">
          <el-col :span="12">
            <el-card shadow="never">
              <div slot="header">跟进时间轴</div>
              <el-timeline>
                <el-timeline-item
                  v-for="item in customer.timeline || []"
                  :key="item.time + item.title"
                  :timestamp="item.time"
                >
                  <div class="crm-timeline-title">
                    {{ item.type }} · {{ item.title }}
                  </div>
                  <div class="crm-timeline-desc">{{ item.desc }}</div>
                </el-timeline-item>
              </el-timeline>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card shadow="never">
              <div slot="header">微信进度 / 附件区</div>
              <div class="crm-kv">
                <span>已发送好友申请</span
                ><b>{{
                  customer.wechatProgress && customer.wechatProgress.sentRequest
                    ? "是"
                    : "否"
                }}</b>
              </div>
              <div class="crm-kv">
                <span>是否已通过</span
                ><b>{{
                  customer.wechatProgress && customer.wechatProgress.approved
                    ? "已通过"
                    : "未通过"
                }}</b>
              </div>
              <div class="crm-kv">
                <span>通过时间</span
                ><b>{{
                  (customer.wechatProgress &&
                    customer.wechatProgress.approvedAt) ||
                  "暂无"
                }}</b>
              </div>
              <div class="crm-kv">
                <span>已发案例</span
                ><b>{{
                  customer.wechatProgress && customer.wechatProgress.sentCase
                    ? "是"
                    : "否"
                }}</b>
              </div>
              <div class="crm-kv">
                <span>已发报价</span
                ><b>{{
                  customer.wechatProgress && customer.wechatProgress.sentQuote
                    ? "是"
                    : "否"
                }}</b>
              </div>
              <div class="crm-kv">
                <span>附件数量</span
                ><b>{{
                  customer.attachments ? customer.attachments.length : 0
                }}</b>
              </div>
              <div class="crm-note">
                <div v-if="customer.publicAt">
                  于 {{ customer.publicAt }} 进入公海池，原因：{{
                    customer.publicReason || "规则触发"
                  }}
                </div>
                <div v-else>
                  当前位于私人池，剩余
                  {{ customer.publicPoolCountdown }}
                  天掉公海，可发起延长保护期申请。
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <div class="crm-detail-side">
        <el-card shadow="never">
          <div slot="header">快捷操作</div>
          <div class="crm-side-actions">
            <el-button
              class="is-outline"
              @click="showDialReserve('主手机号', customer.phone)"
              >一键外呼（待开发）</el-button
            >
            <el-button
              class="is-outline"
              @click="showDialReserve('备用电话', customer.backupPhone)"
              :disabled="!customer.backupPhone"
              >备用电话外呼</el-button
            >
            <el-button class="is-outline" @click="notifyPending('微信联动')"
              >微信联动（待开发）</el-button
            >
            <el-button type="primary" @click="$emit('follow', customer)"
              >新增跟进</el-button
            >
            <el-button @click="$emit('edit', customer)">编辑客户</el-button>
            <el-button @click="$emit('extend', customer)"
              >申请延长保护期</el-button
            >
            <el-button @click="$emit('public', customer)">转公海</el-button>
            <el-button @click="$emit('lost', customer)">转流失</el-button>
          </div>
        </el-card>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import CrmPhoneField from "./PhoneField.vue";

export default {
  name: "CrmCustomerDrawer",
  components: { CrmPhoneField },
  props: {
    visible: { type: Boolean, default: false },
    customer: { type: Object, default: null },
  },
  computed: {
    drawerVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
    mainStatusType() {
      const map = {
        跟进中: "primary",
        已加微信: "success",
        待签约: "danger",
        已签约: "success",
        公海池: "warning",
        已流失: "info",
      };
      return map[(this.customer && this.customer.mainStatus) || ""] || "info";
    },
    intentionType() {
      const map = {
        A高意向: "danger",
        B中意向: "warning",
        C低意向: "info",
        D无意向: "",
        X无效: "info",
      };
      return (
        map[(this.customer && this.customer.intentionLevel) || ""] || "info"
      );
    },
    countdownType() {
      if (!this.customer) return "info";
      if (this.customer.publicPoolCountdown <= 0) return "danger";
      if (this.customer.publicPoolCountdown <= 2) return "warning";
      return "success";
    },
    countdownLabel() {
      if (!this.customer) return "";
      return this.customer.publicPoolCountdown <= 0
        ? "已超期"
        : "剩余 " + this.customer.publicPoolCountdown + " 天";
    },
  },
  methods: {
    notifyPending(label) {
      this.$message.info(
        `${label} 为预留功能，后续可接入网页与手机 App 联动。`
      );
    },
    showDialReserve(label, phone) {
      if (!phone) {
        this.$message.warning(`${label} 暂未填写，当前没有可拨打的电话号码`);
        return;
      }
      this.$message.info(
        `当前为${label}拨号功能预留入口，后续将支持网页点击后由已登录手机 App 自动调起拨号。`
      );
    },
  },
};
</script>

<style scoped>
.crm-detail {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 240px;
  gap: 16px;
}
.crm-hero {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  border-radius: 16px;
  background: #f8fbff;
  border: 1px solid #dbeafe;
  margin-bottom: 16px;
}
.crm-hero-name {
  font-size: 26px;
  font-weight: 700;
  color: #111827;
}
.crm-hero-meta {
  margin-top: 8px;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.crm-tags,
.crm-label-item div {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}
.crm-score {
  min-width: 110px;
  text-align: center;
  background: #fff;
  border-radius: 14px;
  padding: 14px;
  color: #6b7280;
}
.crm-score strong {
  display: block;
  font-size: 30px;
  margin-top: 8px;
  color: #2563eb;
}
.crm-kv {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 0;
  border-bottom: 1px solid #eef2f7;
  font-size: 13px;
}
.crm-kv:last-child {
  border-bottom: none;
}
.crm-kv span {
  color: #6b7280;
}
.crm-kv b {
  color: #111827;
  text-align: right;
}
.crm-call-note {
  margin-top: 14px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #f8fbff;
  border: 1px dashed #dbeafe;
  color: #1d4ed8;
  line-height: 1.7;
}
.crm-label-group {
  display: grid;
  gap: 12px;
}
.crm-label-item {
  display: grid;
  grid-template-columns: 88px minmax(0, 1fr);
  gap: 12px;
  align-items: start;
}
.crm-label-item span {
  color: #6b7280;
  font-size: 13px;
}
.crm-timeline-title {
  font-weight: 700;
  color: #111827;
}
.crm-timeline-desc {
  margin-top: 6px;
  color: #4b5563;
  line-height: 1.7;
}
.crm-note {
  margin-top: 14px;
  border-radius: 12px;
  background: #fff8eb;
  border: 1px dashed #f5d38b;
  padding: 12px 14px;
  color: #9a6700;
  line-height: 1.7;
}
.crm-side-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.crm-side-actions .el-button {
  width: 100%;
}
.crm-side-actions .is-outline {
  border-style: dashed;
}
@media (max-width: 1200px) {
  .crm-detail {
    grid-template-columns: 1fr;
  }
}
</style>
